(() => {
  const visible = (element) => Boolean(element && element.getClientRects().length);

  const initialiseProductTools = (root = document) => {
    root.querySelectorAll('[data-pm-bulk-shortcut]').forEach((shortcut) => {
      const tools = shortcut.closest('[data-pm-product-tools]');
      const target = document.querySelector('[data-pm-bulk-order-target]');
      const hasVisibleBulkOrder = visible(target);

      shortcut.hidden = !hasVisibleBulkOrder;
      if (tools) tools.hidden = !hasVisibleBulkOrder && !tools.querySelector('[data-pm-size-guide]');

      if (shortcut.dataset.pmInitialised === 'true') return;
      shortcut.dataset.pmInitialised = 'true';
      shortcut.addEventListener('click', (event) => {
        event.preventDefault();
        if (!target) return;
        const disclosure = target.querySelector('.pm-bulk-order-disclosure');
        if (disclosure) disclosure.open = true;
        const header = document.querySelector('[id^="shopify-section-"][class*="section-header"]');
        const headerOffset = visible(header) ? header.getBoundingClientRect().height + 24 : 24;
        target.style.scrollMarginTop = `${headerOffset}px`;
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        window.setTimeout(() => target.focus({ preventScroll: true }), 450);
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => initialiseProductTools());
  document.addEventListener('shopify:section:load', (event) => initialiseProductTools(event.target));

  let resizeTimer;
  window.addEventListener('resize', () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(() => initialiseProductTools(), 150);
  });
})();
